<template>
  <div>
    <h1>TEST PAGE</h1>
    <input
            type="email"
            name="email"
            v-model="email"
            placeholder="email"
    />
    <br/>
    <input
            type="password"
            name="password"
            v-model="password"
            placeholder="password"
    />
    <br/>
    <v-btn round outline color="itoviBlue" @click="login" dark>Rounded Button</v-btn>
    <br/>
  </div>
</template>

<script>
  import Api from '../services/api_endpoints'
  export default {
    data () {
      return {
        email: '',
        password: ''
      }
    },
    watch: {
      email (d) {
        console.log('email:', d)
      },
      password (pass) {
        console.log('pass:', pass)
      }
    },
    mounted() {

    },
    methods: {
      async login () {
        const response = await Api.login(this.email, this.password)
        console.log(response.data)
      }
    }
  }
</script>
